module.exports = __webpack_public_path__ + "img/PhilGray.348e1dde.png";